import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _hiders;
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { tracked } from "@glimmer/tracking";
import { registerDestructor } from "@ember/destroyable";
import Service, { service } from "@ember/service";
import { TrackedSet } from "@ember-compat/tracked-built-ins";
import { disableImplicitInjections } from "discourse/lib/implicit-injections";
import { currentPanelKey, customPanels as panels } from "discourse/lib/sidebar/custom-sections";
import { COMBINED_MODE, MAIN_PANEL, SEPARATED_MODE } from "discourse/lib/sidebar/panels";
let SidebarState = disableImplicitInjections(_class = (_class2 = (_hiders = /*#__PURE__*/new WeakMap(), class SidebarState extends Service {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "keyValueStore", _descriptor, this);
    _initializerDefineProperty(this, "currentUser", _descriptor2, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor3, this);
    _initializerDefineProperty(this, "currentPanelKey", _descriptor4, this);
    _initializerDefineProperty(this, "mode", _descriptor5, this);
    _initializerDefineProperty(this, "displaySwitchPanelButtons", _descriptor6, this);
    _initializerDefineProperty(this, "filter", _descriptor7, this);
    _initializerDefineProperty(this, "isForcingAdminSidebar", _descriptor8, this);
    _defineProperty(this, "panels", panels);
    _defineProperty(this, "collapsedSections", new TrackedSet());
    _defineProperty(this, "previousState", {});
    _classPrivateFieldInitSpec(this, _hiders, new TrackedSet());
  }
  get sidebarHidden() {
    return _classPrivateFieldGet(_hiders, this).size > 0;
  }
  registerHider(ref) {
    _classPrivateFieldGet(_hiders, this).add(ref);
    registerDestructor(ref, () => {
      _classPrivateFieldGet(_hiders, this).delete(ref);
    });
  }
  setPanel(name) {
    if (this.currentPanelKey) {
      this.setPreviousState();
    }
    this.currentPanelKey = name;
    this.restorePreviousState();
  }
  get currentPanel() {
    return this.panels.find(panel => panel.key === this.currentPanelKey);
  }
  setSeparatedMode() {
    this.mode = SEPARATED_MODE;
    this.showSwitchPanelButtons();
  }
  setCombinedMode() {
    this.mode = COMBINED_MODE;
    this.currentPanelKey = MAIN_PANEL;
    this.hideSwitchPanelButtons();
  }
  showSwitchPanelButtons() {
    this.displaySwitchPanelButtons = true;
  }
  hideSwitchPanelButtons() {
    this.displaySwitchPanelButtons = false;
  }
  setPreviousState() {
    this.previousState[this.currentPanelKey] = {
      mode: this.mode,
      displaySwitchPanelButtons: this.displaySwitchPanelButtons
    };
  }
  collapseSection(sectionKey) {
    const collapsedSidebarSectionKey = `sidebar-section-${sectionKey}-collapsed`;
    this.keyValueStore.setItem(collapsedSidebarSectionKey, true);
    this.collapsedSections.add(collapsedSidebarSectionKey);
  }
  expandSection(sectionKey) {
    const collapsedSidebarSectionKey = `sidebar-section-${sectionKey}-collapsed`;
    this.keyValueStore.setItem(collapsedSidebarSectionKey, false);
    this.collapsedSections.delete(collapsedSidebarSectionKey);
  }
  isCurrentPanel(panel) {
    return this.currentPanel.key === panel;
  }
  restorePreviousState() {
    const state = this.previousState[this.currentPanelKey];
    if (!state) {
      return;
    }
    if (state.mode === SEPARATED_MODE) {
      this.setSeparatedMode();
    } else if (state.mode === COMBINED_MODE) {
      this.setCombinedMode();
    }
    if (state.displaySwitchPanelButtons) {
      this.showSwitchPanelButtons();
    } else {
      this.hideSwitchPanelButtons();
    }
  }
  get combinedMode() {
    return this.mode === COMBINED_MODE;
  }
  get showMainPanel() {
    return this.currentPanelKey === MAIN_PANEL;
  }
  get currentUserUsingAdminSidebar() {
    return this.currentUser?.use_admin_sidebar;
  }
  get adminSidebarAllowedWithLegacyNavigationMenu() {
    return this.currentUserUsingAdminSidebar && this.siteSettings.navigation_menu === "header dropdown";
  }
  get sanitizedFilter() {
    return this.filter.toLowerCase().trim();
  }
  clearFilter() {
    this.filter = "";
  }
}), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "keyValueStore", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "currentPanelKey", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return currentPanelKey;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "mode", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return COMBINED_MODE;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "displaySwitchPanelButtons", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "filter", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "isForcingAdminSidebar", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
})), _class2)) || _class;
export { SidebarState as default };